/**
 * A CONTA DE SUPORTE (0134, decisão 62): quem administra a plataforma e tem,
 * com o mesmo e-mail, uma pessoa na empresa do cliente para ajudar a
 * parametrizar, dar suporte e ver erros. O papel dela continua o que é, com
 * tudo o que concede; o NOME que a tela escreve é este.
 */
export const ROTULO_DE_SUPORTE = 'SUPORTE';

export interface ContaDeSuporte {
  /** A conta da plataforma está vinculada a esta pessoa (por prova da senha da plataforma). */
  readonly vinculada: boolean;
  /** As duas senhas são a mesma. Diverge quando a da empresa foi trocada por convite. */
  readonly unificada: boolean;
}

/** O papel que a barra e o perfil escrevem: "Suporte" na conta vinculada, o do menu nas outras. */
export function nomeDoPapelNaTela(conta: ContaDeSuporte | null | undefined, doMenu: string | null): string | null {
  return conta?.vinculada === true ? ROTULO_DE_SUPORTE : doMenu;
}
